export const iconFontAwesomeSecurityPersonHarassing = (
	<i className="fa-solid fa-person-harassing"></i>
);
